import { Navigate } from 'react-router-dom';

import { DEFAULT_FLOW_ID } from '#client/config/flowConfig';

const Shop = () => {
  return <Navigate to={DEFAULT_FLOW_ID} />;
};

export default Shop;
